import React from "react"

export const Loading = () => {
  return <div>Authentication in progress...</div>
}
